import { render } from "./CompanyCreate.vue?vue&type=template&id=77b38834&scoped=true"
import script from "./CompanyCreate.vue?vue&type=script&lang=js"
export * from "./CompanyCreate.vue?vue&type=script&lang=js"

import "./CompanyCreate.vue?vue&type=style&index=0&id=77b38834&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b38834"]])

export default __exports__